module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty12.9bd45dad.jpg";